export default {
  translations: {
    header: {
      aboutMenu: {
        support: 'Apoyo',
        help: 'Ayuda',
        about: 'Acerca',
      },
    },
    screens: {
      receivement: {
        follow_up: 'Acompañamiento',
        receivement: 'Recibo',
        requestType: 'Tipo de Solicitud',
        order: 'Pedir',
        invoice: 'Factura Fiscal',
        status: 'Estado',
        series: 'Serie',
        product: 'Producto',
        supplier: 'Proveedor',
        initialDate: 'Fecha Inicio',
        finalDate: 'Fecha Final',
        acceptanceDate: 'Fecha de aceptación',
        details: 'Detalles',
        generateConference: 'Generar Conferencia',
        endDivergence: 'Termina con la Divergencia',
        confirmEndDivergence:
          '¿Estás seguro de que quieres terminar con la divergencia?',
        orderFinisherEnd: 'Pedido completado con discrepancia',
        progress: 'Progresso',
        actions: 'Comportamiento',
        dateApproved: 'Fecha Apro',
        amountSku: 'Ctdd. SKU',
        amount: 'Ctdd',
        dateReceivement: 'Fecha Rec',
        dateEnd: 'Fin Rec',
        alertSeach:
          'Por favor, introduzca fechas con una diferencia máxima de 30 días o filtre por pedido y factura',
        successFilter: 'resultados encontrados',
        resultsNotFound: 'Resultados no encontrados',
        document: 'Documento',
        receiptDate: 'Fecha de recepción',
        endDate: 'Fecha final',
        enterProduct: 'Introduce el producto',
        enterBox: 'Entrar en la caja',
        enterPallet: 'Entrar en la paleta',
        dateChecked: 'Fecha comprobada',
        size: 'Tam.',
        quantity: 'Qtd. NF',
        divergent: 'Divergencia',
        dateReceipt: 'Fecha Rec.',
        successfullyReversed: 'revertido con éxito',
        reversedSuccessfully: 'Recibo revertido con éxito',
        isReverse: '¿Quieres revertir el recibo',
        reverse: 'Revertir',
        youLogin: 'Su nombre de usuario',
        password: 'Contraseña',
        youPassword: 'Su Contraseña',
        autenticateMsg: 'Ups ¡Comprueba tu nombre de usuario y/o contraseña!',
        notLeaderMsg: '¡Solo el líder puede autorizar el reembolso!',
        revertTitleModal: 'Autenticación de líder',
        volumes: 'Volúmenes',
        distributionBox: 'Caja de Distribución',
        campaign: 'Campaña',
        analytics: 'Analítico',
        numberSeries: 'Num. Serie',
        receimentAnalyticsMessage:
          '¡Ingrese fechas con no más de 30 días de diferencia o filtre por pedido u ola!',
        planningSuccess: 'La planificación se completó con éxito.',
        confirmUpdate: '¿Confirma actualizar la recepción?',
        updateMessage:
          'El campo “Devolución” está seleccionado. ¿Está seguro de que desea guardar de todos modos?',
        cageProductOrder: 'Orden de Producto de Jaula',
        productionOrder: 'Orden de Producción',
        cage: 'Jaula',
        boxCagePallet: 'Caja, Jaula o Palé',
        history: 'Historial',
      },
      status: {
        canceled: 'Cancelado',
        divergent: 'Divergente',
        inProgress: 'En proceso',
        finished: 'Finalizado',
        completedDivergent: 'Divergente Completado',
        integrated: 'Integrada OK',
        integratedDivergent: 'Integrada Divergente',
        invoiceDivergent: 'Factura Divergente',
        pending: 'Pendente',
        qualityFailed: 'Calidad Desaprobada',
        transit: 'Tránsito',
      },
      printing: {
        print: 'Imprimir',
        printing: 'Impresión',
        product: 'Producto',
        quantity: 'Cantidad',
        printingMessage: '¡Impresión enviada! ¡Por favor, verifique!',
        messageRequired: '¡Complete los campos obligatorios!',
        oneFilds: '¡Rellena uno de los campos!',
      },
      cardsFilters: {
        results: 'Resultados',
        finished: 'Finalizado',
        completedDivergent: 'Divergente Completado',
        inProgress: 'En Proceso',
        divergent: 'Divergente',
        pending: 'Pendiente',
        totalProgress: 'Progresso Total',
        create: 'Creado',
        planned: 'Planificado',
        progress: 'Progreso',
        resupply: 'Reabastecimiento',
        completedShipment: 'Envío Completado',
        finishedDivergence: 'Terminado C/ Divergencia',
        insufficientStock: 'Existencias Insuficientes',
        awaitingIntegration: 'En espera de Integración',
        checkedQuantity: 'Cantidad Marcada',
        pickingQuantity: 'Cantidad Picking',
        totalAmount: 'Cantidad total',
        startDate: 'Fecha Inicio Separación',
        startTime: 'Separación Inicio Tiempo',
        startTimeEnd: 'Hora de fin de separación',
        endDate: 'Fecha Finalización del Envío',
        endTime: 'Hora Finalización Embarque',
        awaitingBilling: 'En Espera de Facturación',
        awaitingShipment: 'En Espera de Envío',
        awaitingConference: 'Conferencia en Espera',
        shipmentFinished: 'Envío Terminado',
        awaitingRelease: 'En Espera de Lanzamiento',
        divergentQuantity: 'Cantidad divergente',
        amountReceived: 'Cantidad recibida',
        waitingConference: 'Esperando conferencia',
        waitingShipment: 'Esperando embarque',
        orderCancelled: 'Orden cancelada',
        waitingRelease: 'En espera de liberación',
        waitingScreening: 'Esperando la proyección',
        screeningCompleted: 'Evaluación completada',
        update: 'Para actualizar',
        delivered: 'Entregado',
        manualCard: 'Indique el nuevo pedido de reabastecimiento.',
        manualCardOrder: 'Orden actual',
        manualCardText: 'Especifique el orden.',
      },
      structureAdresses: {
        type: 'Tipo',
        description: 'Descripción',
        isActive: '¿Está activo?',
        noFound: 'No se encontró ninguna dirección',
        adreessesFound: 'direcciones encontradas',
        structureEditSuccesses: 'Estructura editada con éxito',
        successDeleteRecordes: 'Registro eliminado con éxito',
        notFoundRecordes: 'No se encontraron registros.',
        wasFound: 'Fue encontrado',
        records: 'registros',
        someError: 'Algo salió mal con la solicitud',
        structureCreate: 'Structure created successfully!',
        structure: 'Estructura',
        titleScreen: 'Crear estructura',
        newStrucutureBtn: 'Nueva Estructura',
        create: 'Crear',
        createStructureTitle: 'Crear estructura',
        edit: 'Para editar',
        successfullyDeleted: '¡Eliminado con éxito!',
        isDeleted: '¿Quieres borrar?',
        status: 'Estado',
        actions: 'Comportamiento',
        delete: 'Borrar',
        statusTrue: 'Activo',
        statusFalse: 'Inactivo',
      },
      address: {
        deposit: 'Depósito',
        type: 'Tipo',
        status: 'Estado',
        adresses: 'Dirección',
        toWalk: 'Andar',
        road: 'Camino',
        modules: 'Módulos',
        level: 'Nivel',
        position: 'Posición',
        resulpply: 'Reabastecimiento',
        capacity: 'Capacidad',
        resu: 'Reab.',
        actions: 'Comportamiento',
        delete: 'Borrar',
        edit: 'Para editar',
        editStatus: 'Editar Estado',
        newAddress: 'Nueva Dirección',
        storage: 'Almacenamiento',
        notFound: 'No hay registros de direcciones',
        foundResults: 'resultados encontrados',
        error: 'Error',
        branch: 'Subsidiaria',
        shippingCompany: 'Compañía de envios',
        branchsNotName: 'No hay sucursales con ese nombre.',
        editedSuccessfully: '¡Editado con éxito!',
        saveButtonTitle: 'Ahorrar',
        notLeave: '¡No deje el campo de estado vacío!',
        updateStatus: '¡Estado actualizado con éxito!',
        deleteSuccess: 'Eliminado con éxito',
        isDelete: '¿Está seguro de que desea eliminar la dirección',
        deleteAddress: 'Dirección eliminada',
        createAddressTitle: 'Crear Dirección',
        createAddressSuccess: '¡Creado con éxito!',
        addressExist: '¡Dirección existente!',
        importFile: 'Importar Archivo',
        importSuccess: '¡Archivo importado con éxito!',
        uploadFile: 'Subir archivo',
        choiceFile: 'Elija el archivo para upload.',
        structureExist: 'Estructura existente!',
      },
      logAddress: {
        product: 'Producto',
        address: 'Dirección',
        initialDate: 'Fecha Inicio',
        finalDate: 'Fecha Final',
        box: 'Caja',
        pallet: 'Paleta',
        type: 'Tipo',
        noRecordes: '¡No se encontraron registros!',
        logStorage: 'Log Almacenamiento',
        quantityPalete: 'Cantidad Palets',
        quantityBox: 'Cantidad Caja',
        quantity: 'Cantidad',
        manufacturer: 'Fabricante',
        descriptionProduct: 'Descripción del producto',
        dateStorage: 'Fecha de Almacenamiento',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por producto o dirección',
      },
      orderFollowUp: {
        title: 'Orden',
        followUp: 'Acompañamiento',
        orderType: 'Tipo Orden',
        client: 'Cliente',
        period: 'Período',
        clientBranch: 'Client/Subsidiaria',
        receive: 'Recibió',
        planning: 'Planificación',
        finished: 'Finished',
        endShipment: 'Finalizar Envío',
        resultsNotFound: 'Resultados no encontrados.',
        recordsFound: 'Fue encontrado',
        clientAndBranch: 'Cliente/Subsidiaria',
        quantity: 'Cantidad',
        received: 'Recibió',
        check: 'Controlar',
        color: 'Color',
        orderProgress: 'Progreso del Pedido',
        branchsNotName: 'No hay sucursales con ese nombre.',
        printing: 'Impresión',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por ordem',
        separationStart: 'Fecha de inicio de la separación',
        code: 'Código',
        pageOrder: 'Página',
        channel: 'Canal/',
      },
      reverseOrder: {
        errorTheRequest: 'Error: La solicitud',
        thisStatusCreate: 'esto ya es como el estado creado!',
        orderStatus: 'Estado del orden',
        changedSuccessfully: 'changed successfully!',
        noRecordesFound: 'No se encontraron registros.',
        reverse: 'Contrarrestar',
        wave: 'Ola',
        editStatusTitle: 'Editar Estado - Orden:',
        dateOrder: 'Fecha Orden',
        quantityPieces: 'Ctd de Piezas',
        newWave: 'Nueva Ola',
        alertSearch:
          '¡Ingrese fechas con una diferencia máxima de 30 días o filtre por orden u ola!',
      },
      createWave: {
        included: 'incluido',
        onWave: 'en la ola',
        notIncluded: 'no incluido',
        branchsNotName: 'No hay sucursales con ese nombre.',
        picking: 'Cosecha',
        createWave: 'Crear ola',
        taxUnit: 'UT',
        customerBranch: 'Cliente/Sucursal',
        quantityPieces: 'Qtd Piezas',
        newWave: 'Nueva Ola',
        selectedOrder: 'pedido(s) seleccionado(s)',
        priority: 'Prioridad',
        splitVolume: 'Volumen Dividido?',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por pedido.',
        preWavePicking: 'Preparación de pedidos por oleadas (pre-wave)',
      },
      followPicking: {
        branchsNotName: 'No hay sucursales con ese nombre.',
        picking: 'Cosecha',
        editUser: 'Editar Usuario',
        changeUser: 'Cambiar Usuario',
        editUserSuccess: 'Usuario editado con éxito',
        followPicking: 'Seguimiento de la Conferencia',
        separationFollowUp: 'Seguimiento de separaciones',
        priority: 'Prioridad',
        customerBranch: 'Cliente/Sucursal',
        quantityPieces: 'Qtd. Piezas',
        quantityPicking: 'Qtd. Cosecha',
        quantityChecked: 'Qtd. Tomprobado',
        dateOrder: 'Fecha Orden',
        dateFinal: 'Fecha Final',
        document: 'Documento',
        startDate: 'Fecha de inicio:',
        finalDate: 'Fecha final:',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por ola y orden.',
        monitoringPickingReplenishment: 'Abastecimiento de picking',
      },
      pickingConference: {
        product: 'Producto:',
        isResult: 'comprobado con éxito. Orden:',
        picking: 'Cosecha',
        conference: 'Conferencia',
        conferenceDetails: 'Detalle de la Conferencia',
        finalize: 'Finalizar!',
        conferenceFinished: '¡Conferencia finalizada!',
        boxAlreadyAddressed: 'Caja ya direccionada!',
        boxNotExist: '¡La caja no existe!',
        boxNotBelong: '¡La caja no pertenece al pedido!',
        invalidBarcode: 'Código de barras no válido',
        validatedSucces: '¡Caja y EAN validados con éxito!',
        quantityExceeded: '¡Cantidad excedida!',
        insertBox: '¡Por favor, inserte una caja para recoger!',
        endConference: '¿Está seguro de que desea finalizar la conferencia?',
        barCode: 'Cód. barra',
        code: 'Código de Barras',
        box: 'Caja',
        check: 'Controlar',
        conferred: 'Conferido',
        qty: 'Qtd.',
        boxType: 'Tipo de caja',
        bathModalTitle: 'Lote',
        selectBath: 'Seleccionar el Lote',
        validity: 'Validez',
        checkedProduct: 'Producto Verificado',
        alreadyPackage: '¡Producto ya empaquetado!',
        invalidBarcodeByProduct: '¡Código no válido para este pedido!',
        notBarcode: '¡Rellena el código de barras!',
        grouping: 'Agrupamiento',
        depositCod: 'Cod. Depósito',
        despositDesc: 'Desc. Depósito',
        addressCode: 'Códi. Dirección',
        addressDesc: 'Desc. Dirección',
        quantityVisit: 'Cant. Visitas',
        quantityParts: 'Cant. Partes',
        reportVisit: 'Visíta Picking',
        confirmRevertMsg: 'Confirmar reembolso del producto',
      },
      transferenceFollowUp: {
        transfer: 'Transferir',
        origin: 'Origen',
        destiny: 'Destino',
        unit: 'Unidad',
        type: 'Tipo',
        transferDate: 'Fecha de Transferencia',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por unidad.',
      },
      expeditionFollowUp: {
        expedition: 'Expedición',
        query: 'Consulta',
        state: 'Estado',
        dispatchDate: 'Fecha de Envio',
        customerBranch: 'Cliente/Sucursal',
        dispatchUser: 'Usuario Despacho',
        codeOrder: 'Cód. Orden',
        codeExpedition: 'Cód. Expedición',
        validProduct: 'Producto Valido',
        startDate: 'Fecha de Inicio del Envío',
        endDate: 'Fecha de Finalización del Envío',
        branchsNotName: 'No hay sucursales con ese nombre.',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por pedido.',
        notFound: '¡No se encontraron detalles del envío!',
        reportDelivery: 'Informe de Entregas',
      },
      boarding: {
        boarding: 'Embarque',
        packingList: 'Lista Embalaje',
        customerBranch: 'Cliente/Sucursal',
        invoiceQuantity: 'Qtd. NF',
        volumeQuantity: 'Qtde. Volumen',
        exportButton: 'Exportar listas de embalaje en PDF',
        requestCode: 'Código orden',
        orderType: 'Tipo de orden',
        packingDetails: 'Detalles Empaque',
        recordFound: 'registros encontrados',
        agent: 'Agente',
        enterAgent: 'Ingrese el agente',
        agentError: 'Error. ¡Conéctate con tu agente!',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por lista de empaque.',
      },
      manualOrder: {
        manualOrder: 'Registro manual',
        fileUpload: 'Subir archivo',
        register: 'Registro',
        requireFilds: 'Rellene los campos obligatorios',
        receipt: 'Recibo:',
        successfullyCreated: 'creado con exito!',
        order: 'Order:',
        created: 'creado!',
        operation: 'Operación',
        chooseOperation: 'Elige la operación',
        prohibited: 'Prohibido',
        exit: 'Salida',
        chooseType: 'Elige un tipo',
        enterInvoice: 'Introduce la factura',
        series: 'Serie',
        date: 'Date',
        branchCustomer: 'Código cliente ERP/Sucursal',
        carrierCode: 'Código de transportista',
        supplier: 'Proveedor',
        chooseSupplier: 'Elegir proveedor',
        items: 'Elementos',
        deletedItems: 'Objetos eliminados',
        deletedItem: 'Elemento eliminado',
        withSuccess: 'con éxito',
        ordem: 'Orden',
        delete: 'Borrar',
        validData: 'Introduce datos válidos',
        addedSuccessfully: 'gregado exitosamente!',
        nameAndCode: 'No hay productos con este nombre/código',
        chooseProduct: 'Elige un producto',
        enterAmount: 'Introduce una cantidad',
        toAdd: 'Para agregar',
        chooseUpload: 'Elija el archivo para cargar.',
        liftFile: 'Subir archivo',
        chooseRegistration: 'Elija el formulario de registro',
        quantityOfZero:
          'Hay productos con la cantidad igual a cero o no completada.',
        manualTitle: 'Orden Manual',
        registerTitle: 'Registro',
      },
      parameters: {
        parameters: 'Parámetro',
        administration: 'Administración',
        successfullyEdited: '¡Estructura editada con éxito!',
        enterParemeter: 'Por favor ingrese el parámetro',
        parametersDescription: 'Por favor ingrese la descripción del parámetro',
        value: 'Valor',
        parentStatus: 'Estado de los padres',
        toPresent: 'Apresentar',
        childStatus: 'Child Status',
        consultationPeriod: 'Entrar al Periodo de Consulta',
      },
      registerProduct: {
        searchProduct: '¡Busca un producto!',
        thereProducts: 'No hay productos',
        productsFound: 'productos encontrados',
        register: 'Registro',
        productCode: 'Código del producto',
        marked: 'Marcado',
        unchecked: 'Desenfrenado',
        productEdited: 'Producto editado con éxito',
        active: 'Activo',
        level: 'Nivel',
        height: 'Altura',
        width: 'Ancho',
        length: 'Comprimento',
        weight: 'Peso',
        component: 'Componente',
        brandCode: 'Código de marca',
        receipt: 'Recibo',
        receiptInDays: 'Recibo (en días)',
        exit: 'Salida',
        parameters: 'Parámetros',
        marketingStructure: 'Estructura de mercadeo',
        departureInDays: 'Salida (en días)',
        batchControl: 'Control Lotes',
        controlsValidity: 'Validez de los Controles',
        controlsReceipt: 'Recepción de lotes Controles',
        receiptValidity: 'Vigencia del recibo Controles',
        constrolStorage: 'Lote de almacenamiento Controles',
        storageValidity: 'Validez de almacenamiento Controles',
        constrolSeparation: 'Separación de lotes Control',
        separationValidity: 'Vigencia de Separación Controles',
        checkControl: 'Compruebe el control Lotes',
        validityCheck: 'Comprobación de validez Control',
        notFieldsEmpty: 'No dejes campos vacíos',
        colorOrDescription: 'Color o Descripción',
        colorDesc: 'Color/Desc',
        delete: 'Borrar',
      },
      produtivityConference: {
        produtivity: 'Productividad',
        conference: 'Conferencia',
        name: 'Nombre',
        summaryTable: 'Tabla de Resumen',
        analyticalTable: 'Mesa Analítica',
        totalHours: 'Horas totales',
        ordersTime: 'Tiempo de pedidos',
        amountOrder: 'Qtd. Pedido',
        amountPending: 'Qtd. Pendiente',
        amountPackaged: 'Qtd. Empaquetado',
        addressesTime: 'Qtd. Direcciones Hora',
        amountAddresses: 'Qtd. Direcciones',
        amountSeparated: 'Qtde. Apartadp',
        productTime: 'Tiempo del producto',
        amountProduct: 'Qtd. Producto',
        researchDate: 'Fecha de Investigación',
        dateHours: 'Datos/Hora',
        fisrtMessage: 'resultado(s) se encontraron en el análisis y',
        lastMessage: 'resultado(s) encontrado(s) en sintético',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por nombre.',
        avgHours: 'H. Promedio Ini.',
        endAvgHours: 'H. Promedio Fin',
        totalHourOrders: 'Pedidos Horas T.',
        quantityHours: 'Qtd. Pedidos Horas T.',
        quantityAddress: 'Qtd. Dir. Hora T.',
        totalAddress: 'Qtd. Direcciones T.',
        productHours: 'Producto Hora T.',
        quantityHoursTotal: 'Qtde. Producto T.',
        printMsg: 'Producto 100% comprobado, ¿quieres imprimir?',
        store: 'Almacenar',
      },
      produtivityStorage: {
        notFieldEmpty: 'No dejes este campo vacío',
        choiceDate: '¡Elige una fecha de inicio y finalización!',
      },
      reportsStock: {
        boarding: 'Embarcar',
        brand: 'Marca',
        address: 'Dirección',
        descriptionProduct: 'Descripción del Producto',
        codeRequest: 'Código de Solicitud',
        reserved: 'Reservado',
        available: 'Disponible',
        inbound: 'Inbound',
        outBound: 'OutBound',
        destinationStore: 'Tienda de destino',
        reservation: 'Reserva',
      },
      invoiceDivergent: {
        reports: 'Informes',
        report: 'Informe',
        orderDivergent: 'Orden Divergente',
        series: 'Serie',
        date: 'Fecha',
        invoiceQuantity: 'Qtd. Nota Fiscal',
        orderQuantity: 'Qtd. Orden',
        alertSearch:
          'Ingrese fechas con una diferencia máxima de 30 días o filtre por pedido.',
      },
      ressupply: {
        ressupply: 'Reabastecimiento',
        origin: 'Orige',
        destiny: 'Destino',
        priority: 'Prioridad',
        reports: 'Informes',
        supply: 'Suministrar',
        creatSupply: 'Crear Suministrar',
        request: 'Pedido',
        createSubRomaning: 'Crear subremante',
        SubRomaning: 'Subremante',
        qtyFirstFase: 'Cant. Primera Fase',
        homeCollection: 'Primera fase de recogida en el hogar',
        endCollection: 'Fim Fase de Recogida en el Hogar',
        qtyLastFase: 'Cant. Segunda Fase',
        lastCollection: 'Recogida a Domicilio Segunda Fase',
        endLastCollection: 'Fin de la Recolección de la Segunda Fase',
        fase: 'Fase',
        qtdRessuply: 'Cant. Reabastecimiento',
      },
      insufficient: {
        insufficient: 'Insufficient',
        reports: 'Informes',
        priority: 'Prioridad',
      },
      separation: {
        reports: 'Informes',
        separation: 'Separación',
        quantityPickink: 'Qtd. Cosecha',
        quantityOrder: 'Qtd. Orden',
        series: 'Serie',
        nameClient: 'Nombre Cliente',
        codeClient: 'Cod. Cliente',
        codShippingCompany: 'Cod. Compañía de envios',
        descriptionAddress: 'Desc. Dirección',
        billingIssue: 'Problema de facturación',
        broadcastTime: 'Tiempo de Transmisión',
        billingDate: 'Fecha de facturación',
        homeSeparation: 'Separación de viviendas',
        endSeparation: 'Separación final',
        separated: 'Separada',
        separationDuration: 'Duración de la separación',
        billingTime: 'Tiempo de Facturación',
        dispatchTime: 'Tiempo de Expedición',
        boardingTime: 'Tiempom de Embarque',
        billing: 'Facturación',
      },
      conference: {
        reports: 'Informes',
        conference: 'Conferencia',
        quantityConference: 'Qtd. Conferencia',
        quantityOrder: 'Qtd. Orden',
        series: 'Serie',
        nameClient: 'Nombre Cliente',
        integrationDate: 'Fecha de Integración',
        homeConference: 'Inicio Conferencia',
        endConference: 'Fin de la conferencia',
        finalize: 'Finalizar',
        station: 'Station',
        selectStation: 'Seleccione la Estación',
        errorMessage:
          '¡Ups! Asegúrese de que todos los pedidos y estaciones estén llenos',
        durationConference: 'Duración de la separación',
      },
      reportReceipt: {
        receipt: 'Recibo',
        batch: 'Lote',
        enterBach: 'Ingrese al lote',
        reports: 'Informes',
        integrationDate: 'Fecha de Integración',
        series: 'Serie',
        enterSeries: 'Entra en la serie',
        enterVersion: 'Ingresse la versión',
        alertSearch:
          'Introduzca fechas con una diferencia máxima de 30 días o filtre por pedido o producto.',
      },
      dashboard: {
        awaitingBilling: 'En Espera de Facturación',
        awaitingIntegration: 'En espera de Integración',
        conference: 'Conferencia',
        ddressesUsed: 'Direcciones utilizadas',
        stock: 'Existencias',
        expedition: 'Expedition',
        insufficient: 'Insuficiente',
        requests: 'Peticiones',
        pickingProgress: 'Selección divergente',
        divergentPicking: 'Divergent Picking',
        plannedPicking: 'Recolección Planificada',
        resupply: 'Reabastecimiento',
      },
      reportStock: {
        stored: 'Almacenado',
        shipped: 'Enviado',
        invoiced: 'Facturado',
      },
      stockTurnover: {
        title: 'Rotación de Inventario',
        howItWorks: '¿Cómo funciona?',
        turnoverSituation: 'Situación de rotación',
        totalSkus: 'Total de SKUs',
        averageTurnover: 'Rotación promedio',
        highTurnover: 'Alta rotación',
        mediumTurnover: 'Rotación media',
        lowTurnover: 'Baja rotación',
        noTurnover: 'Sin rotación',
        stoppedStock: 'Stock detenido',
        entries: 'Entradas',
        exits: 'Salidas',
        orderQty: 'Cant. Pedidos',
        currentStock: 'Stock Actual',
        turnover: 'Rotación',
        coverage: 'Cobertura',
        daysSinceLastExit: 'Días desde la última salida',
        situation: 'Situación',
        tipTotalSkus:
          'Productos que tuvieron movimiento en el período o tienen stock actual.',
        tipAverageTurnover:
          'Promedio de rotación de los productos con salidas en el período. Los productos sin salidas no se incluyen.',
        tipHighTurnover:
          'Rotación superior al 120% de la rotación promedio de la operación.',
        tipMediumTurnover: 'Rotación entre el 80% y el 120% del promedio.',
        tipLowTurnover: 'Rotación por debajo del 80% del promedio.',
        tipStoppedStock:
          'Sin ninguna salida en el período y con stock actual mayor que cero.',
        tipEntries: 'Cantidad recibida (verificación física) en el período.',
        tipExits: 'Cantidad de pedidos con descuento de stock en el período.',
        tipOrderQty: 'Pedidos distintos con salida del producto en el período.',
        tipCurrentStock:
          'Saldo actual en ubicaciones (suma por EAN del producto).',
        tipTurnover: 'Salidas en el período ÷ stock actual.',
        tipCoverage:
          'Stock actual ÷ promedio diario de salidas. Cuántos días dura el stock al ritmo del período.',
        tipDaysSinceLastExit:
          'Días entre la última salida registrada (cualquier fecha) y la fecha final buscada.',
        tipSituation:
          'Clasificación de la rotación del producto comparada con la rotación promedio de la operación.',
      },
      abcCurve: {
        title: 'Curva ABC',
        howItWorks: '¿Cómo funciona?',
        situation: 'Situación',
        registeredCurve: 'Curva registrada',
        suggestedCurve: 'Curva sugerida',
        totalSkus: 'Total de SKUs',
        curveA: 'Curva A',
        curveB: 'Curva B',
        curveC: 'Curva C',
        divergent: 'Divergentes',
        noRegistration: 'Sin registro',
        separations: 'Separaciones',
        pieces: 'Piezas',
        participation: '% Participación',
        accumulated: '% Acumulado',
        tipTotalSkus: 'Productos con separaciones en el período.',
        tipCurveA:
          'Productos que suman hasta el 80% de las separaciones del período.',
        tipCurveB:
          'Productos entre el 80% y el 95% del acumulado de separaciones.',
        tipCurveC:
          'Productos por encima del 95% del acumulado de separaciones.',
        tipDivergent: 'Curva registrada diferente a la curva sugerida.',
        tipNoRegistration: 'Productos sin curva ABC en el registro.',
        tipSeparations:
          'Pedidos en los que el producto fue separado en el período.',
        tipPieces:
          'Cantidad total separada. No entra en el cálculo de la curva.',
        tipParticipation:
          'Separaciones del producto ÷ total de separaciones del período.',
        tipAccumulated:
          'Suma acumulada del % de participación en el orden del ranking.',
      },
      pack: {
        packCreatSuccess: 'Paquete creado exitosamente',
        pack: 'Crear Paquete',
        validatedSucces: '¡Caja y EAN validados con éxito!',
        errorValidated:
          'Error. ¡El color y el producto son diferentes de los que ya figuran en la lista!',
      },
      streetOccupation: {
        totalOccupation: 'Total Ocupado',
        occupationStreet: 'Ocupación de la calle',
        occupation: 'Ocupado',
        empty: 'Vacío',
      },
      waveRedirectModal: {
        products: 'Productos',
        unitarians: 'Unitarios',
        individualOrders: 'Pedidos unitarios por producto',
        title: 'Abrir creación de ola',
        badge: 'INSTRUCCIONES PARA LA CREACIÓN DE OLAS',
        description:
          'Al confirmar, se abrirá la pantalla Crear ola con los siguientes parámetros:',
        createWave: 'Crear ola',
        productFilter: 'Filtro de producto',
        selectedOption: 'Opción seleccionada',
        oneSkuOnePiece: 'Pedidos con 1 SKU y 1 unidad',
        infoText:
          'La opción seleccionada se aplicará automáticamente en la pantalla de creación de olas.',
        understood: 'Entendido',
      },
      commom: {
        storage: 'Almacenamiento',
        detail: 'Detalle',
        details: 'Detalles',
        actions: 'Comportamiento',
        user: 'Usuario',
        order: 'Orden',
        status: 'Estado',
        initialDate: 'Fecha Inicio',
        startTime: 'Hora de Inicio',
        finalDate: 'Fecha Final',
        endTime: 'Hora de Finalización',
        totalTime: 'Tiempo Total',
        shippingCompany: 'Compañía de envios',
        branch: 'Subsidiaria',
        progress: 'Progreso',
        records: 'registros',
        product: 'Producto',
        descriptionProduct: 'Descripción del producto',
        box: 'Caja',
        pallet: 'Paleta',
        grid: 'Grade',
        size: 'Tamaño',
        invoice: 'Nota fiscal',
        recordsFound: 'Fue encontrado',
        client: 'Cliente',
        edit: 'Editar',
        saveButtonTitle: 'Ahorrar',
        orderType: 'Tipo Orden',
        resultsNotFound: 'Resultados no encontrados.',
        period: 'Período',
        orderDate: 'Fecha Orden',
        yes: 'Sí',
        no: 'No',
        create: 'Crear',
        followUp: 'Hacer un Seguimiento',
        wave: 'Ola',
        color: 'Color',
        quantity: 'Cantidad',
        toClean: 'Limpiar',
        search: 'Buscar',
        finalize: 'Finalizar',
        code: 'Código',
        successFilter: 'resultados encontrados',
        description: 'Descripción',
        error: 'Error',
        branchsNotName: '¡No hay sucursales con ese nombre!',
        toAdd: 'Para agregar',
        deposit: 'Depósito',
        level: 'Nivel',
        stock: 'Existencias',
        reports: 'Informes',
        dashboard: 'Panel de control',
        autenticate: 'Autenticación',
        seller: 'Vendedor',
        formPayment: 'Forma de pago',
        total: 'Total',
        barCode: 'Código de barras',
        enterBarCode: 'Introduce el código de barras',
        print: 'Impresora',
        printMessage: 'Seleccione la impresora',
        printMsg: 'Impresión enviada. ¡Por favor verifique!',
        cage: 'Jaula',
        expirationData: 'Fecha de validez',
        quantityDivergente: 'Qtd. Divergente',
        storageRequest: 'Solicitud de Almacenamiento',
        quantityPack: 'Qtd. Pack',
        totalParts: 'Partes totales',
        alertAllFields: '¡Rellena todos los campos!',
        class: 'Clase',
        model: 'Modelo',
        selectStreet: 'Seleccione la calle',
        conect: 'Conectar',
        observation: 'Observación',
        heatMap: 'Mapa de Calor',
        distribution: 'Distribución',
        pleaseFill: '¡Rellene al menos uno de los campos!',
        downloadFile: 'Descargar archivo',
        onlyLeader: '¡Único líder!',
        downloadFileModel: '¿Descargar archivo de plantilla?',
        imports: 'Importaciones',
        unitMeasure: 'Unidad Medida',
        summary: 'Resumen',
        dateBetween: '¡Filtra fechas con un máximo de 30 días de diferencia!',
        assembly: 'Asamblea',
        disassembly: 'Desmontaje',
        palletErrorSearch:
          'Filtra fechas con una diferencia máxima de 30 días, o por el palet o por la caja.',
        produced: 'Producido',
        start: 'Comenzar',
        end: 'Fin',
        workingHours: 'Horas de Trabajo',
        promotion: 'Promoción',
        curve: 'Curva',
        stored: 'Almacenado',
        store: 'Almacenar',
        city: 'Ciudad',
        deliveryDate: 'Fecha de Entrega',
        buy: 'Comprar',
        transaction: 'Transacción',
        file: 'Archivo',
        import: 'Importar',
        previous: 'Anterior',
        hours: 'Hora',
        department: 'Departamento',
        family: 'Familia',
        group: 'Grupo',
        category: 'Categoría',
        collect: 'Recolectar',
        update: 'Actualizar',
        finishing: 'Refinamiento',
        simpleCode: 'Cód.',
        internal: 'Interno',
        composition: 'Composición',
        voltage: 'Voltaje',
        title: 'Título',
        questions: 'Preguntas',
        newQuestion: 'Nueva pregunta',
        photoAlways: 'Foto Siempre',
        photoNotAlways: 'Foto no Está Bien',
        justificationAlways: 'Justificación Siempre',
        justificationNotOk: 'La Justificación no está bien',
        delivery: 'Entrega',
        photo: 'Foto',
        cubage: 'Cubicación',
        integrations: 'Integración',
        change: 'Cambiar',
        fillInAllTheBatches: '¡Rellena todos los lotes!',
        productCannotBeRepeated: '¡El producto no puede repetirse!',
        productDoesNotExist: '¡El producto no existe!',
        batchesEditedSuccessfully: '¡Lotes editados con éxito!',
        invoiceAndOrderFieldsRequired:
          'Los campos Factura y Pedido son obligatorios',
        qtyBoxHr: 'Cant. Cajas/Hora T.',
        qtyBox: 'Cant. Cajas T.',
        qtyBoxesHour: 'Cant. Cajas Hora',
        qtyBoxes: 'Cant. Cajas',
        editallBatches: 'Editar todos los Lotes',
        changed: 'Cambió',
        main: 'Principal',
        external: 'Externo',
        loading: 'Cargando',
        frozen: 'Congelado',
        refrigerated: 'Refrigerado',
        fractional: 'Fraccionario',
        approved: 'Aprobado',
        failed: 'Fallido',
        handling: 'Manejo',
        allow: 'Permitir',
        IdentifierERP: 'Identificador en ERP',
        new: 'Nuevo',
        emptyAddresses: '¿Direcciones vacías?',
        sale: 'Venta',
        boxes: 'Cajas',
        version: 'Versión',
        toDivide: 'Dividir',
        splitAfterPlanning: 'Orden Dividida Después de la Planificación',
        sequence: 'Secuencial',
        packages: 'Paquetes',
        of: 'De',
        until: 'Hasta',
        successfullySplit: '¡Orden dividida exitosamente!',
        printed: 'Impreso',
        percentageServed: 'Porcentaje atendido',
        situation: 'Situación',
        toAlter: 'Alterar',
        justification: 'Justificación',
        cost: 'Costo',
        minimum: 'Mínimo',
        alert: 'Alerta',
        indicators: 'Indicadores',
        signature: 'Firma',
        alertFilterGeneric:
          'Filtrar fechas con una diferencia máxima de 30 días o por',
        iReceive: 'Recibo',
        belowThe: 'Debajo del',
        valueIn: 'Valor en',
        time: 'Tiempo',
        unitary: 'Unitario',
        lung: 'Pulmón',
        target: 'Objetivo',
        salesOrder: 'Pedido de Venta',
        attention: 'Atención',
        normal: 'Normal',
        critical: 'Crítico',
        outOfBreath: 'Sin aire en los pulmones',
        suggested: 'Sugerido',
        cart: 'Carrito',
        shelves: 'Shelves',
        table: 'Mesa',
        approver: 'Aprobador',
        protocol: 'Protocolo',
        boxDisassembly: 'Desmontaje de cajas - Manejo de SKU',
        forecast: 'Pronóstico',
        affected: 'Afectados',
        lastOne: 'El último',
        separator: 'Separador',
        requested: 'Solicitado',
        separationDivergence: 'Divergencia de Separación',
        original: 'Original',
        prodution: 'Producción',
        alternative: 'Alternativa',
        ventilated: 'Ventilada',
        honeycomb: 'Colmena',
        ventilation: 'Ventilación',
        fulfilled: 'Atendida',
        guide: 'Guía',
        freigh: 'Envío',
        registered: 'Registrada',
        issued: 'Emitido',
        only: 'Solamente',
      },
      integration: {
        title: 'Supervisión',
        subTitle: 'Procesos',
        process: 'Proceso',
        last_sync_at: 'Última ejecución',
        last_sync_status: 'Éxito en la última ejecución',
        next_sync_at: 'Siguiente ejecución',
        running: 'Corriendo',
        stopped: 'Interrumpido',
        error: 'Error',
      },
      followAge: {
        daysInStock: 'Días en stock',
        tenDays: '10 Días',
        twentyDays: '20 Días',
        thirtyDays: '30 Días',
      },
      followWave: {
        followWave: 'Seguimiento de olas',
        amountOrder: 'Qtde. Pedidos',
        amountProduct: 'Qtde. Productos',
        waveDate: 'Ola de Fecha',
      },
      initialIntegration: {
        module: 'Módulo',
        autorization: 'Autorización',
        inventoryDate: 'Fecha de Inventario',
        createdDateInventory: 'Fecha de Creación',
        selectFile: 'Select the file',
        newInventoryTitle: 'Nuevo inventario',
        inventory: 'Inventario',
        inventoryCode: 'Código Inventario',
        home: 'Hogar',
        selectClass: 'Seleccionar Clase',
        detailInventory: 'Detalles Inventario',
        firstCollect: 'Primera colección',
        lastCollectt: 'Última Colección',
        message: 'Mensaje',
        errorMessage:
          '¡Error al crear una intención en las direcciones siguientes!',
        notFoundMessage:
          'Resultados no encontrados. ¡Compruebe el filtro o el inventario seleccionado!',
        selectInventory: '¡Seleccione un inventario!',
      },
      scoreInventory: {
        score: 'Puntaje',
        bar: 'Bar',
        brand: 'Marca',
        reference: 'Referencia',
        notScoreMsg: '¡Este Inventario no ha comenzado a contar!',
        totalAddresses: 'Direcciones Totales',
        firstCount: 'Primer conteo',
        secondCount: 'Segundo conteo',
        thistCount: 'Tercer recuento',
        consolidated: 'Consolidado',
        countedAddresses: 'Direcciones contadas',
        itemsCounted: 'Artículos contados',
        skusCounted: 'SKUs Contados',
        totalConsolidated: 'Total Consolidados',
        notFoundAddress: '¡El inventario no contiene direcciones!',
      },
      finallyInventory: {
        finallyInventory: 'Finalizar Inventario',
        reopenInventory: 'Reabrir Invetario',
        updateStock: 'Actualizar stock de WMS',
        updateMessage: '¡El stock de WMS se actualizó exitosamente!',
        warnningMessage:
          '¿Estás seguro de querer actualizar el stock del WMS con el Inventario consolidado?',
      },
      divergentInventory: {
        difference: 'Diferencia',
        statusCollect: 'Estado Colección',
        statusAddress: 'Dirección Estado',
        divergentAddress: 'Abordar Divergencia',
        piecesCounted: 'Piezas Contadas',
        productDivergent: 'Produto Divergente',
      },
      statusAddress: {
        addressCode: 'Código Dirección',
        addressResetMsg: '¡Restablecimiento de dirección exitoso!',
        confirmResetMsg: 'Confirmar borrado de la dirección',
      },
      printOutBox: {
        generateBox: 'Generar',
        header: 'Encabezamiento',
        selectAgent: 'Seleccionar Agente',
        conectedSuccesfully: 'Agente conectado exitosamente',
        alertMsg: '¡Filtro por descripción o producto!',
        purchaseOrder: 'Orden de compra',
      },
      parametrization: {
        parameterize: 'Parametrizar',
        collected: 'Recogido',
        resetProductMsg: '¡Restablecimiento del producto exitoso!',
        questionReset: '¿Quieres restablecer el producto',
        theAddress: 'en la dirección',
      },
      printWave: {
        waveCode: 'Código de Onda',
        planningDate: 'Fecha de Planificación',
      },
      printDanfe: {
        keyInvoice: 'Llave Fac',
        corporateName: 'Razón Social',
        stateRegistration: 'Inscripción Estadual',
        typeNote: 'Tipo de Nota',
        totalValue: 'Valor Total',
        issuanceDate: 'Fecha de Emisión',
      },
      printMail: {
        mail: 'Correo',
        name: 'Nombre del Recipiente',
        observation: 'Nota. Recipiente',
        description: 'Nota. Recipiente',
        number: 'Num. Remitente',
        zipCode: 'CP. Remitente',
        city: 'Ciudad del remitente',
        shipping: 'Desc. Compañía de envios',
      },
      indicators: {
        indicator: 'Indicador',
        alertSearch: '¡Filtra por un máximo de 31 días y selecciona el tipo!',
        table: 'Mesa',
        pricessing: 'Tratamiento',
        peoples: 'Gente',
        process: 'Procesado',
        manPerDay: 'Dia del Hombre',
        price: 'Precio',
        alarm: 'Alarma',
        hanger: 'Percha',
      },
      docking: {
        screening: 'Cribado',
        pieces: 'Regiones',
        driver: 'Conductor',
        maturyti: 'Madurez',
        newRoute: 'Nueva Ruta',
        transport: 'Transporte',
        routes: 'Ruta',
        capacity: 'Capacidad',
        createRoute: 'Crear Ruta',
        editRoute: 'Editar Ruta',
      },
      quality: {
        quality: 'Calidad',
        parameters: 'Parámetros',
        editParameters: 'Editar parámetro',
        salveParameters: 'Guardar parámetro',
        newParameters: 'Nuevo Parámetro',
        descriptionsTitle: 'Descripción del Parámetro',
        defaultTitle: 'Frecuencia de muestreo para control de calidad',
        fromBox: 'De cajas X',
        upTheBox: 'Hasta X Cajas',
        quantityQuality: 'Cant. Calidad',
        deleteParameters: 'Eliminar Parámetro',
        detailed: 'Detallado',
        new: 'Nueva',
        newTitle: 'Nuevo Título',
        questionUpdateSuccess: '¡Pregunta actualizada exitosamente!',
        questionCreateSuccess: '¡Pregunta creada exitosamente!',
        createTitleSuccess: '¡Título creado exitosamente!',
        updateTitleSuccess: '¡Título actualizado exitosamente!',
        takePhoto: 'Toma Foto',
        LoadDevice: 'Cargar en el dispositivo',
        analysisReport: 'Informe de análisis de control de calidad',
        capture: 'Captura',
      },
      qualityResponse: {
        savedSuccessfully: '¡Foto guardada con éxito!',
        mainUploadedSuccessfully: '¡Foto principal cargada con éxito!',
        notFound: '¡Pedido no encontrado!',
        foundSuccessfully: '¡Pedido encontrado con éxito!',
        initialLoadError: '¡Error al cargar los datos iniciales!',
        answers: 'Respuestas',
        withJustification: 'Con Justificación',
        withoutJustification: 'Sin Justificación',
        withPhoto: 'Con Foto',
        withoutPhoto: 'Sin Foto',
        total: 'Total',
        totalAnalyzed: 'Total Analizado',
        finalizeReport: 'Finalizar Informe',
        exportResponsePDF: 'Exportar PDF',
        exitResponse: 'Salir',
        analysisResult: 'Resultado del análisis',
        selectResult: 'Seleccione el resultado del análisis de calidad.',
        approveReport: 'Aprobar informe pericial',
        approveReportPDF:
          'Aprueba el informe y habilita la exportación del PDF.',
        rejectReprove: 'Rechazar informe',
        justificationReport: 'Rechaza el informe y exige una justificación.',
        infoReportPDF:
          'Al aprobar, se habilitará la exportación del PDF. Al rechazar, será necesario proporcionar una justificación.',
        reasonRejection: 'Justificación de la reprobación',
        infoRejection: 'Justificación de la reprobación',
        remainingCharacters: 'Caracteres restantes',
        inspectionUse: 'Usuario de la inspección',
      },
      importFileMessages: {
        messageError: 'No se pudo importar el archivo.',
        noDataProcessed:
          'No se procesan datos. El archivo puede estar vacío o no ser válido.',
        failedImportFile: 'No se pudo importar el archivo.',
        carrierCreated: '¡Transportadores creados exitosamente!',
        followingHeaders: 'Faltan los siguientes encabezados en el archivo:',
        missingRequired: 'Falta campo obligatorio:',
        noTabs:
          'No se encontraron pestañas en el archivo. Consulta el contenido.',
        headersNotFound: 'Encabezados no encontrados en el archivo.',
        repeatCode: 'Código repetido encontrado:',
        theLine: 'en la linea',
        branchesCreated: '¡Sucursales creadas exitosamente!',
        suppliersCreated: '¡Proveedores creados exitosamente!',
        customersCreated: '¡Clientes creados exitosamente!',
        invoiceCreated: '¡Facturas creadas exitosamente!',
      },
      label: {
        field: 'Campo',
        label: 'Etiqueta',
        alignment: 'Alineación',
        decimalPlace: 'Lugar Decimal',
        labelCreated: '¡Etiqueta creada con éxito!',
        barcodeParameterization: 'Parametrización de códigos de barras',
      },
    },
    components: {
      search: {
        title: 'Buscar',
        clear: 'Limpiar',
        advancedFilters: 'Filtros Avanzados',
        closeAdvancedFilters: 'Menos Filtros',
        upload: 'Subir Archivo',
        loading: 'Cargando',
        filter: 'Filtros',
      },
      table: {
        export: 'Exportar',
        entries: 'Registros',
        to: 'a',
        noResults: 'No se han encontrado resultados',
      },
      user: {
        greetings: 'Hola',
      },
      pageMode: {
        close: 'Cerrar',
        back: 'Volver',
        printOut: 'Imprimir',
      },
      confirmationModal: {
        close: 'Cerrar',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
      userPopper: {
        profile: 'Perfil',
        config: 'Ajustes',
      },
    },
  },
};
